module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-800.5578f647.eot";